import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var Avatar = function (_a) {
    var src = _a.src, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 50 : _c;
    return (_jsx("div", { className: 'flex items-center justify-center rounded-full bg-gray-200 text-gray-700', style: {
            width: "".concat(size, "px"),
            height: "".concat(size, "px"),
        }, children: _jsx("img", { src: src !== null && src !== void 0 ? src : "https://ui-avatars.com/api/?name=".concat(name || 'Anonymous', "&background=random"), alt: name || 'Anonymous', className: 'w-full h-full object-cover rounded-full', onError: function (e) {
                e.target.src =
                    "https://ui-avatars.com/api/?name=".concat(name || 'Anonymous', "&background=random");
                e.target.onerror = null; // Suppress the error so it doesn't break the component
            } }) }));
};
